<amplify-authenticator>
  <amplify-sign-in hide-sign-up="true" username-alias="email" header-text="Manufacturing Login" slot="sign-in"></amplify-sign-in>
</amplify-authenticator>
